"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardPage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/PageWizard/PageWizardTabs");
require("../../types");
const ContentWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: ${({ contentHeight }) => contentHeight || 'initial'};
`;
ContentWrapper.displayName = 'WizardPageContentWrapper';
const Content = styled_components_1.default.div `
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'block')};
  flex-shrink: 1;
  width: 100%;
`;
Content.displayName = 'WizardPageContent';
const WizardPage = ({ id, actions, currentStep, currentStepIdx, enableStepsSchema, loading, onExitPage, onKeyPress, pageDescription, pageTitle, pageHeaderControls, panel, panelWidth, panelMinWidth, tabWidth, selectHandler, steps, hasBack = true, style, actionsStyle, }) => {
    return (react_1.default.createElement(components_1.PageWizardLayout, { "data-selector-id": `wizard-page-${id}`, panelWidth: panelWidth, panelMinWidth: panelMinWidth, onKeyPress: (e) => {
            if (e.keyCode === components_1.KeyCode.Escape) {
                onExitPage === null || onExitPage === void 0 ? void 0 : onExitPage();
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
        }, loading: loading, header: react_1.default.createElement(components_1.PageWizardHeader, { hasBack: hasBack, onBackClick: () => onExitPage === null || onExitPage === void 0 ? void 0 : onExitPage(), title: pageTitle || '', description: pageDescription, rightAddon: pageHeaderControls ? react_1.default.createElement(react_1.default.Fragment, null, pageHeaderControls) : undefined }), tabs: react_1.default.createElement(components_1.PageWizardTabs, { width: tabWidth, tabs: steps.reduce((tabs, step, idx) => {
                if (!step.hidden) {
                    tabs.push({
                        title: step.tabTitle,
                        active: idx === currentStepIdx,
                        disabled: step.disabled || !enableStepsSchema[step.tag],
                        onClick: () => {
                            if (!step.disabled && enableStepsSchema[step.tag]) {
                                selectHandler(idx);
                            }
                        },
                    });
                }
                return tabs;
            }, []) }), style: style, content: react_1.default.createElement(ContentWrapper, { contentHeight: currentStep.contentHeight },
            react_1.default.createElement(Content, { fullWidth: !!currentStep.fullWidthContent }, currentStep.body || react_1.default.createElement(react_1.default.Fragment, null, null))), footer: react_1.default.createElement(components_1.PageWizardActions, { primary: actions, style: actionsStyle }), panel: panel, fullWidthContent: currentStep.fullWidthContent }));
};
exports.WizardPage = WizardPage;
exports.WizardPage.displayName = 'WizardPage';
//# sourceMappingURL=WizardPage.js.map